const loadmores = [...document.querySelectorAll('.js-filters-more')];

loadmores.map(loadmore => {

    loadmore.addEventListener('click', () => {
        loadmore.previousElementSibling.classList.toggle('more');
        if(loadmore.innerHTML === 'Laad meer...'){
            loadmore.innerHTML = 'Laad minder...';
        }else {
            loadmore.innerHTML = 'Laad meer...';
        }

    });

    console.log(loadmore);
});

